import {IPagedResult} from '../common/PagedResult';
import {IContactUpdatesSearchModel, ContactUpdatesSearchModel} from './ContactUpdatesSearchModel';
import {Paging} from '../common/Paging';

export class ContactUpdatesSearchPaged implements IContactUpdatesSearchPaged {
  paging?: Paging | undefined;
  result?: ContactUpdatesSearchModel[] | undefined;

  constructor(data?: IContactUpdatesSearchPaged) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.paging = Data["paging"] ? Paging.fromJS(Data["paging"]) : <any>undefined;
      if (Array.isArray(Data["result"])) {
        this.result = [] as any;
        for (let item of Data["result"])
          this.result!.push(ContactUpdatesSearchModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContactUpdatesSearchPaged {
    data = typeof data === 'object' ? data : {};
    let result = new ContactUpdatesSearchPaged();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    return data;
  }
}

export interface IContactUpdatesSearchPaged {
  paging?: Paging | undefined;
  result?: ContactUpdatesSearchModel[] | undefined;
}